var map = {
	"./code-flow-template.ts": [
		32750,
		750
	],
	"./default-template.ts": [
		53446
	],
	"./flowchart-template.ts": [
		38738,
		738
	],
	"./knowledge-graph-template.ts": [
		12685,
		685
	],
	"./mindmap-template.ts": [
		10068,
		68
	],
	"./org-chart-template.ts": [
		37249,
		81
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 97065;
module.exports = webpackAsyncContext;